import React, { ReactNode, useState } from 'react';
import { Row, Col, Space, Typography, Card, Pagination } from 'antd';

interface StatItem {
  label: string;
  value: number;
  percentage?: number;
  icon?: ReactNode;
}

interface StatListProps {
  title: string;
  icon?: ReactNode;
  items: StatItem[];
  formatValue?: (value: number) => string;
  height?: number;
  pageSize?: number;
  style?: React.CSSProperties;
  itemStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
  percentageStyle?: React.CSSProperties;
  paginationStyle?: React.CSSProperties;
}

export const StatList: React.FC<StatListProps> = ({
  title,
  icon,
  items,
  formatValue = (value) => value.toString(),
  height = 400,
  pageSize = 5,
  style,
  itemStyle,
  labelStyle,
  valueStyle,
  percentageStyle,
  paginationStyle,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  // Sort items by value in descending order
  const sortedItems = [...items].sort((a, b) => b.value - a.value);
  
  // Calculate pagination
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedItems = sortedItems.slice(startIndex, startIndex + pageSize);
  
  return (
    <Card
      title={
        <Space>
          {icon}
          {title}
        </Space>
      }
      style={{ height, ...style }}
    >
      <div style={{ height: 'calc(100% - 70px)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div className="space-y-4">
          {paginatedItems.map((item) => (
            <Row 
              key={item.label} 
              justify="space-between" 
              align="middle" 
              className="hover:bg-muted/50 p-4 rounded-lg transition-colors"
              style={{
                border: '1px solid var(--border)',
                marginBottom: '8px',
                ...itemStyle,
              }}
            >
              <Col>
                <Space direction="vertical" size={1}>
                  <Typography.Text strong style={{ fontSize: '16px', ...labelStyle }}>
                    {item.label}
                  </Typography.Text>
                  {item.percentage && (
                    <Typography.Text type="secondary" style={{ fontSize: '12px', ...percentageStyle }}>
                      {item.percentage}% of total downloads
                    </Typography.Text>
                  )}
                </Space>
              </Col>
              <Col>
                <Typography.Text strong style={{ fontSize: '16px', color: 'hsl(var(--primary))', ...valueStyle }}>
                  {formatValue(item.value)}
                </Typography.Text>
              </Col>
            </Row>
          ))}
        </div>
        <Pagination
          simple
          current={currentPage}
          total={items.length}
          pageSize={pageSize}
          onChange={setCurrentPage}
          style={{ marginTop: '16px', textAlign: 'right', ...paginationStyle }}
        />
      </div>
    </Card>
  );
}; 